import React from "react";
import VoltageGauge from "../../components/VoltageGauge";
import CurrentBar from "../../components/CurrentBar";
import { useTranslation } from "react-i18next";

export default function MultimeterDashboard({ data, deviceModel, deviceId }) {
  const { t } = useTranslation();
  if (!data) {
    return (
      <div className="p-6 text-center text-slate-500">
        {t('hierarchy.loading')}
      </div>
    );
  }

  const vtr = data.ratios?.VTR || 1;

  return (
    <div className="space-y-6">
      {/* VOLTAJ + AKIM BLOĞU */}
      <div className="bg-white border border-slate-200 rounded-xl shadow-sm p-5">
        <h3 className="text-sm font-semibold text-slate-700 mb-3">
          {t('dashboard.phaseVoltages')}
        </h3>

        <div className="flex flex-col lg:flex-row gap-8">
          {/* FAZ + HAT VOLTAJLARI */}
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 flex-1">
            {/* Faz gerilimleri */}
            {["VL1", "VL2", "VL3"].map((key) => (
              <VoltageGauge
                key={key}
                label={key}
                value={data.voltages?.[key]}
                vtr={vtr}
                isLine={false}
              />
            ))}

            {/* Hat gerilimleri */}
            {["VL12", "VL23", "VL31"].map((key) => (
              <VoltageGauge
                key={key}
                label={key}
                value={data.voltages?.[key]}
                vtr={vtr}
                isLine={true}
              />
            ))}
          </div>

          {/* AKIM BARLARI */}
          <div className="flex flex-row items-end justify-center gap-8 min-w-[220px]">
            <CurrentBar label="I1" value={data.currents?.I1} max={100} />
            <CurrentBar label="I2" value={data.currents?.I2} max={100} />
            <CurrentBar label="I3" value={data.currents?.I3} max={100} />
            <CurrentBar
              label="IΣ"
              value={
                (data.currents?.I1 ?? 0) +
                (data.currents?.I2 ?? 0) +
                (data.currents?.I3 ?? 0)
              }
              max={300}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
